<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisContactSearch from 'dashboard/components-next/LaisContactSearch.vue';

const emit = defineEmits(['selectRequesterContact']);

const proposalForm = defineModel('proposalForm', {
  type: Object,
  required: true,
});
const selectedRequesterContact = defineModel('selectedRequesterContact', {
  type: Object,
  default: null,
});
const requesterContactQuery = defineModel('requesterContactQuery', {
  type: String,
  default: '',
});

const clearSelectedContact = () => {
  if (!proposalForm.value?.contact_id && !proposalForm.value?.contactId) return;
  selectedRequesterContact.value = null;
  proposalForm.value.contact_id = null;
  proposalForm.value.contactId = null;
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section class="grid gap-4">
    <LaisContactSearch
      v-model="selectedRequesterContact"
      v-model:query="requesterContactQuery"
      label="Buscar cliente"
      helper="Selecione um cliente existente em cards ou preencha os dados abaixo para criar um novo vínculo."
      @select="emit('selectRequesterContact', $event)"
    />
    <div class="rounded-lais border border-lais-border bg-lais-bg-soft p-4">
      <p class="text-[14px] font-semibold text-lais-text">
        Dados do interessado
      </p>
      <p class="mt-1 text-[13px] text-lais-text-body">
        Use estes campos para novo cliente ou ajuste dos dados selecionados.
      </p>
    </div>
    <div class="grid gap-3 md:grid-cols-2">
      <div class="flex flex-col gap-1 md:col-span-2">
        <label
          class="text-[11px] font-semibold uppercase tracking-wide text-lais-text-muted"
        >
          Nome
        </label>
        <input
          v-model="proposalForm.requester_name"
          type="text"
          placeholder="Nome do interessado"
          class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text placeholder:text-lais-text-muted focus:border-lais-primary focus:outline-none"
          @input="clearSelectedContact"
        />
      </div>
      <div class="flex flex-col gap-1">
        <label
          class="text-[11px] font-semibold uppercase tracking-wide text-lais-text-muted"
        >
          E-mail
        </label>
        <input
          v-model="proposalForm.requester_email"
          type="email"
          placeholder="Preencha com o seu e-mail"
          class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text placeholder:text-lais-text-muted focus:border-lais-primary focus:outline-none"
          @input="clearSelectedContact"
        />
      </div>
      <div class="flex flex-col gap-1">
        <label
          class="text-[11px] font-semibold uppercase tracking-wide text-lais-text-muted"
        >
          Telefone
        </label>
        <input
          v-model="proposalForm.requester_phone"
          type="tel"
          placeholder="(11) 00000-0000"
          class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text placeholder:text-lais-text-muted focus:border-lais-primary focus:outline-none"
          @input="clearSelectedContact"
        />
      </div>
    </div>
  </section>
</template>
